export default __webpack_public_path__ + "static/benifitImg-14621e2599eced9adb26910b89d671f9.png";